import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
// import SignUp from "layouts/authentication/sign-up";
import FleetAnalytics from "layouts/FleetAnalytics";
import Icon from "@mui/material/Icon";
import EditDetails from "layouts/create/EditDetails";
import GeoFence from "layouts/create/geoFence";
import Journey from "layouts/create/JourneyDetails";
import RouteReplay from "layouts/routeReplay";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import DocumentUpload from "layouts/create/documentUpload";
import Alerts from "layouts/alerts/recentAlerts";
import AlertConfiguration from "layouts/alerts/alertConfiguration";
import AlertDashboard from "layouts/alerts/dashboard";
import VehicleGroup from "layouts/management/vehicleGroup";
import UserManagement from "layouts/management/userManagement";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
// import Tables from "layouts/tables";
import AccountDetailsForm from "layouts/tables/data/accountDetail";
import BulkStudentUpload from "layouts/tables/data/excelupload";
import AllReports from "layouts/Reports/allreports";
import NotificationLogs from "layouts/Reports/notificationReport/notificationlogs";
import JourneyLogs from "layouts/Reports/JourneyReport/journeyReport";
import GeofenceReport from "layouts/Reports/GeofecnceReport/geofenceReport";
import IgnitionReport from "layouts/Reports/IgnitionReport/ignitionReport";
import VehiclePerformanceReport from "layouts/Reports/vehiclePerformanceReport/vehiclePerformanceReport";
import TrackingReport from "layouts/Reports/TrackingReport/trackingreport";
import StopTimingReport from "layouts/Reports/Stop Timing Report/stoptimingreport";
import RouteDeviationReport from "layouts/Reports/Route Deviation Report/routeDeviationReport";
import HaltReport from "layouts/Reports/Halt Report/haltReport";
import DistanceReport from "layouts/Reports/Distance Report/distancereport";
import StopDistanceReport from "layouts/Reports/Stop Distance Report/stopdistancereport";
import VehicleReport from "layouts/Reports/Vehicle Report/vehiclereport";
import AttendanceReport from "layouts/Reports/Attendance Report/attendanceReport";
import CachementDashboard from "layouts/Reports/CachementMap/cachementDashboard";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Notification from "layouts/create/notification";
import ProtectedRoute from "ProtectedRoute";
import Planning from "layouts/Planning";
import AdminReports from "layouts/admin/components/Card";
// import Accounts from "layouts/admin/components/Accounts";
import OrgAdmin from "layouts/admin/components/OrgAmin";
import Billing from "layouts/billing";
import WalletDetails from "layouts/admin/components/WalletDetails";
import { id } from "date-fns/locale";
import RunningJourney from "layouts/admin/components/AllJourney";
import DeviceConfig from "layouts/admin/components/DeviceConfig";
import { A } from "ol/renderer/webgl/FlowLayer";
import Live from "layouts/openPages/live";
import Live_Google from "layouts/openPages/live_ol_google";
import Live_SingleTrack from "layouts/openPages/live_singleTrack/live";
import Live_Lite from "layouts/openPages/live_lite/live";
import Live_Temp from "layouts/openPages/live_temp/live";
import SuperGeoFence from "layouts/admin/components/Card/components/supergeofence";
import Tables from "layouts/tablessss";
import JobRoleUpload from "layouts/jobRole/jobRoleUpload/jobRoleForm";
import JobRoleReport from "layouts/jobRole/jobRoleReport";
import FuelLogUpload from "layouts/fuelLog/fuelLogUpload/fuelLogUpload";
import JobRoleAnalytics from "layouts/jobRole/jobRoleAnalytics";
import FuelLogReport from "layouts/fuelLog/fuelLogReport/fuelLogReport";
import FuelLogAnalytics from "layouts/fuelLog/fuelLogAnalytics";
import Camera from "layouts/create/LiveCamera";
import AllCustomers from "layouts/admin/components/AllCustomers/allCustomers";
import DaywiseDistanceReport from "layouts/Reports/Daywise_Distance_Report/daywisedistancereport";
import BoatReport from "layouts/Reports/Boat Report/boatReport";
import GeofenceTripReport from "layouts/Reports/GeofenceTripReport/geofenceTripReport";
import GenVehicleReport from "layouts/admin/components/genVehicleReport/component/genVehicleReport";
import GenerateVehicleReport from "layouts/admin/components/genVehicleReport";
import Media_GalleryLogs from "layouts/Reports/Media_Gallery/media_GalleryLogs";
import SearchStudentReport from "layouts/admin/components/SearchStudent";
import VehicleCreationReport from "layouts/admin/components/VehicleCreation";
import OdometerDistanceReport from "layouts/Reports/OdometerDistanceReport/odometerDistanceReport";
import RouteOptimization from "layouts/Reports/RouteOptimization/cachementDashboard";
import PasswordRReset from "layouts/admin/components/PasswordReset/component/passwordreset";
import PasswordReset from "layouts/admin/components/PasswordReset";
import EVReport from "layouts/Reports/Ev_Report/EVReport";
import OBDDashboard from "./layouts/Obddashboard/Obddashboard";
// import Tables from "layouts/tables";
const routes = [
  {
    id: "20",
    type: "collapse",
    name: "Super Admin",
    key: "admin",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/superAdmin",
    component: (
      <ProtectedRoute>
        <AdminReports />
      </ProtectedRoute>
    ),
  },
  {
    id: "100",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "OrgAdmin",
    key: "orgAdmin",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/OrgAdmin",
    component: (
      <ProtectedRoute>
        <OrgAdmin />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "101",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "WalletDetails",
    key: "walletDetails",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/Wallet-Details",
    component: (
      <ProtectedRoute>
        <WalletDetails />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "102",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "RunningJourney",
    key: "runningJourney",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/Running-Journey",
    component: (
      <ProtectedRoute>
        <RunningJourney />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "103",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "DeviceConfig",
    key: "deviceConfig",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/Device-Config",
    component: (
      <ProtectedRoute>
        <DeviceConfig />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "104",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "All Customers",
    key: "allCustomers",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/All-Customers",
    component: (
      <ProtectedRoute>
        <AllCustomers />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "210",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "Generate Vehicle Report",
    key: "genVehicleReport",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/Gen-Vehicle-Report",
    component: (
      <ProtectedRoute>
        <GenerateVehicleReport />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "211",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "Search Student",
    key: "searchStudent",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/Search-Student",
    component: (
      <ProtectedRoute>
        <SearchStudentReport />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "212",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "Search Student",
    key: "searchStudent",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/Vehicle-Creation",
    component: (
      <ProtectedRoute>
        <VehicleCreationReport />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "213",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "Oranization Password Reset",
    key: "PasswordReset",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/SuperAdmin/Password-Reset",
    component: (
      <ProtectedRoute>
        <PasswordReset />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "1",
    type: "collapse",
    name: "Live Map",
    key: "dashboard",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/Live-Map",
    component: (
      // <ProtectedRoute>
      <Dashboard />
      // {/* </ProtectedRoute> */}
    ),
  },
  {
    id: "4",
    type: "collapse",
    name: "FleetAnalytics",
    key: "fleetAnalytics",
    icon: <Icon fontSize="small">bar_chart_icon</Icon>,
    route: "/Fleet_Analytics",
    component: (
      <ProtectedRoute>
        <FleetAnalytics />
      </ProtectedRoute>
    ),
  },
  {
    id: "7",
    bpid: "1",
    type: "collapse",
    name: "Route Replay",
    key: "routeReplay",
    icon: <Icon fontSize="small">replay</Icon>,
    route: "/Route-Replay",
    component: (
      <ProtectedRoute>
        <RouteReplay />
      </ProtectedRoute>
    ),
  },
  // {
  //   id: "102",
  //   type: "collapse",
  //   name: "Accounts",
  //   key: "accounts",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/Accounts",
  //   component: (
  //     <ProtectedRoute>
  //       <Tables />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    id: "14",
    type: "collapse",
    name: "Reports",
    key: "All-Reports",
    icon: <AssessmentIcon fontSize="small" />,
    route: "/All-reports",
    component: (
      <ProtectedRoute>
        <AllReports />
      </ProtectedRoute>
    ),
    visible: true,
  },
  // {
  //   id: "141",
  //   bpid: "14",
  //   mpid: "14",
  //   type: "collapse",
  //   name: "Notification Logs",
  //   key: "Notification-Logs",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Notification-logs",
  //   component: (
  //     <ProtectedRoute>
  //       <NotificationLogs />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "142",
  //   bpid: "14",
  //   mpid: "14",
  //   type: "collapse",
  //   name: "Journey Reports",
  //   key: "Journey-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Journey-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <JourneyLogs />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "147",
  //   bpid: "14",
  //   mpid: "14",
  //   type: "collapse",
  //   name: "Geofence Reports",
  //   key: "Geofence-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Geofence-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <GeofenceReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  {
    id: "161",
    bpid: "6",
    mpid: "6",
    type: "collapse",
    name: "GeoFence",
    key: "geoFence",
    route: "/Reports/Geofence-trip-reports",
    icon: <Icon fontSize="small">fence</Icon>,
    component: (
      <ProtectedRoute>
        <GeofenceTripReport />
      </ProtectedRoute>
    ),
  },
  {
    id: "148",
    bpid: "14",
    mpid: "14",
    type: "collapse",
    name: "Ignition Reports",
    key: "Ignition-Reports",
    icon: <Icon fontSize="small"></Icon>,
    route: "/Reports/Ignition-reports",
    component: (
      <ProtectedRoute>
        <IgnitionReport />
      </ProtectedRoute>
    ),
    visible: false,
  },
   {
    id: "180",
    type: "collapse",
    name: "Ev Reports",
    key: "EV-Reports",
    icon: <Icon fontSize="small"></Icon>,
    route: "/Reports/EV-reports",
    component: (
      <ProtectedRoute>
        <EVReport />
      </ProtectedRoute>
    ),
    visible: false,
  },
    {
    id: "181",
    type: "collapse",
    name: "OBD Dashboard",
    key: "OBD-Dashboard",
    icon: <Icon fontSize="small">speed</Icon>,
    route: "/Reports/OBD-dashboard",
    component: (
      <ProtectedRoute>
        <OBDDashboard />
      </ProtectedRoute>
    ),
    visible: true,
  },
  // {
  //   id: "149",
  //   bpid: "14",
  //   mpid: "14",
  //   type: "collapse",
  //   name: "Vehicle Performance Reports",
  //   key: "Vehicle-Performance-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Vehicle-Performance-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <VehiclePerformanceReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "151",
  //   bpid: "14",
  //   mpid: "14",
  //   type: "collapse",
  //   name: "Tracking Reports",
  //   key: "Tracking-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Tracking-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <TrackingReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "152",
  //   type: "collapse",
  //   name: "Stop Timing Reports",
  //   key: "Stop-Timing-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Stop-timing-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <StopTimingReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "153",
  //   type: "collapse",
  //   name: "Route Deviation Reports",
  //   key: "Route-Deviation-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Route-deviation-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <RouteDeviationReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  {
    id: "154",
    type: "collapse",
    name: "Halt Reports",
    key: "Halt-Reports",
    icon: <Icon fontSize="small"></Icon>,
    route: "/Reports/Halt-reports",
    component: (
      <ProtectedRoute>
        <HaltReport />
      </ProtectedRoute>
    ),
    visible: false,
  },
  // {
  //   id: "155",
  //   type: "collapse",
  //   name: "Distance Reports",
  //   key: "Distance-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Distance-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <DistanceReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "162",
  //   type: "collapse",
  //   name: "Odometer Distance Report",
  //   key: "odometer-Distance-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Odometer-distance-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <OdometerDistanceReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  {
    id: "160",
    type: "collapse",
    name: "Daywise Distance Reports",
    key: "Daywise-Distance-Reports",
    icon: <Icon fontSize="small"></Icon>,
    route: "/Reports/Daywise-distance-reports",
    component: (
      <ProtectedRoute>
        <DaywiseDistanceReport />
      </ProtectedRoute>
    ),
    visible: false,
  },
  // {
  //   id: "156",
  //   type: "collapse",
  //   name: " Stop Distance Reports",
  //   key: "Stop-Distance-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Stop-distance-report",
  //   component: (
  //     <ProtectedRoute>
  //       <StopDistanceReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "157",
  //   type: "collapse",
  //   name: "Vehicle Reports",
  //   key: "Vehicle-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Vehicle-reports",
  //   component: (
  //     <ProtectedRoute>
  //       <VehicleReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "158",
  //   type: "collapse",
  //   name: "Attendance Reports",
  //   key: "Attendance-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Attendance-Reports",
  //   component: (
  //     <ProtectedRoute>
  //       <AttendanceReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "159",
  //   type: "collapse",
  //   name: "Cachement Dashboard",
  //   key: "Cachement-Dashboard",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/Reports/Cachement-Dashboard",
  //   component: (
  //     <ProtectedRoute>
  //       <CachementDashboard />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  {
    id: "163",
    type: "collapse",
    name: "Media Gallery",
    key: "media-Gallery",
    icon: <Icon fontSize="small"></Icon>,
    route: "/Reports/Media-Gallery",
    component: (
      <ProtectedRoute>
        <Media_GalleryLogs />
      </ProtectedRoute>
    ),
    visible: false,
  },
  // {
  //   id: "160",
  //   type: "collapse",
  //   name: "Boat Report",
  //   key: "Boat-Reports",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/boat-Report",
  //   component: (
  //     <ProtectedRoute>
  //       <BoatReport />
  //     </ProtectedRoute>
  //   ),
  //   visible: false,
  // },
  // {
  //   id: "12",
  //   bpid: "1",
  //   type: "collapse",
  //   name: "Messaging",
  //   key: "messaging",
  //   icon: <Icon fontSize="small">messageIcon</Icon>,
  //   collapse: [
  //     {
  //       id: "122",
  //       bpid: "12",
  //       mpid: "12",
  //       type: "collapse",
  //       name: "SendNotification",
  //       key: "sendNotification",
  //       route: "/Messaging/Send-Notification",
  //       icon: <Icon fontSize="small">edit</Icon>,
  //       component: (
  //         <ProtectedRoute>
  //           <Notification />
  //         </ProtectedRoute>
  //       ),
  //     },
  //   ],
  // },
  {
    id: "6",
    bpid: "1",
    type: "collapse",
    name: "Create",
    key: "create",
    icon: <Icon fontSize="small">add_circle</Icon>,
    collapse: [
      {
        id: "65",
        bpid: "6",
        mpid: "6",
        type: "collapse",
        name: "Vehicle Details",
        key: "editDetails",
        route: "/Create/Edit-Details",
        icon: <Icon fontSize="small">edit</Icon>,
        component: (
          <ProtectedRoute>
            <EditDetails />
          </ProtectedRoute>
        ),
      },
      {
        id: "16",
        bpid: "6",
        mpid: "6",
        type: "collapse",
        name: "GeoFence",
        key: "geoFence",
        route: "/Create/GeoFence",
        icon: <Icon fontSize="small">fence</Icon>,
        component: (
          <ProtectedRoute>
            <GeoFence />
          </ProtectedRoute>
        ),
      },
      // {
      //   id: "66",
      //   bpid: "6",
      //   mpid: "6",
      //   type: "collapse",
      //   name: "Journey Details",
      //   key: "journey",
      //   route: "/Create/Journey",
      //   icon: <Icon fontSize="small">map</Icon>,
      //   component: (
      //     <ProtectedRoute>
      //       <Journey />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        id: "64",
        bpid: "6",
        mpid: "6",
        type: "collapse",
        name: "Account Details",
        key: "account-details",
        icon: <Icon fontSize="small">person</Icon>,
        route: "/Create/Account-details",
        component: (
          <ProtectedRoute>
            <AccountDetailsForm />
          </ProtectedRoute>
        ),
      },
      // {
      //   id: "67",
      //   bpid: "6",
      //   mpid: "6",
      //   type: "collapse",
      //   name: "DocumentUpload",
      //   key: "documentUpload",
      //   route: "/Create/doucument-Upload",
      //   icon: <Icon fontSize="small">map</Icon>,
      //   component: (
      //     <ProtectedRoute>
      //       <DocumentUpload />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   id: "68",
      //   bpid: "6",
      //   mpid: "6",
      //   type: "collapse",
      //   name: "Live camera",
      //   key: "livecamera",
      //   route: "/Create/Camera",
      //   icon: <CameraAltIcon fontSize="small" />,
      //   component: (
      //     <ProtectedRoute>
      //       <Camera />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   id: "69",
      //   bpid: "6",
      //   mpid: "6",
      //   type: "collapse",
      //   name: "Route Optimization",
      //   key: "routeoptimization",
      //   route: "/Create/Route-optimization",
      //   icon: <AltRouteIcon fontSize="small" />,
      //   component: (
      //     <ProtectedRoute>
      //       <RouteOptimization />
      //     </ProtectedRoute>
      //   ),
      // },
    ],
  },
  // {
  //   id: "17",
  //   type: "collapse",
  //   name: "Planning",
  //   key: "planning",
  //   icon: <Icon fontSize="small">map</Icon>,
  //   route: "/planning",
  //   component: (
  //     <ProtectedRoute>
  //       <Planning />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    id: "19",
    type: "collapse",
    name: "Alerts",
    key: "alerts",
    icon: <Icon fontSize="small">notifications_icon </Icon>,
    collapse: [
      {
        id: "199",
        bpid: "19",
        mpid: "19",
        type: "collapse",
        name: "Recent Alerts",
        key: "recentAlerts",
        route: "/Alerts/Recent-Alerts",
        icon: <Icon fontSize="small">reportProblemIcon</Icon>,
        component: (
          <ProtectedRoute>
            <Alerts />
          </ProtectedRoute>
        ),
      },
      {
        id: "191",
        bpid: "19",
        mpid: "19",
        type: "collapse",
        name: "Alert Dashboard",
        key: "alertDashboard",
        route: "/Alerts/Alert-Dashboard",
        icon: <Icon fontSize="small">reportProblemIcon</Icon>,
        component: (
          <ProtectedRoute>
            <AlertDashboard />
          </ProtectedRoute>
        ),
      },
      {
        id: "195",
        bpid: "19",
        mpid: "19",
        type: "collapse",
        name: "Alert Configuration",
        key: "alertConfiguration",
        route: "/Alerts/Alert-Configuration",
        icon: <Icon fontSize="small">reportProblemIcon</Icon>,
        component: (
          <ProtectedRoute>
            <AlertConfiguration />
          </ProtectedRoute>
        ),
      },
    ],
  },

  {
    id: "24",
    type: "collapse",
    name: "Management",
    key: "management",
    icon: <Icon fontSize="small">manage_accounts_icon </Icon>,
    collapse: [
      {
        id: "196",
        bpid: "24",
        mpid: "24",
        type: "collapse",
        name: "Vehicle Group",
        key: "vehicleGroup",
        route: "/Management/Vehicle-Group",
        icon: <Icon fontSize="small">directions_bus_filled_Icon </Icon>,
        component: (
          <ProtectedRoute>
            <VehicleGroup />
          </ProtectedRoute>
        ),
      },
      {
        id: "197",
        bpid: "24",
        mpid: "24",
        type: "collapse",
        name: "User Management",
        key: "userManagement",
        route: "/Management/user-Management",
        icon: <Icon fontSize="small">personIcon</Icon>,
        component: (
          <ProtectedRoute>
            <UserManagement />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    id: "62",
    bpid: "24",
    mpid: "24",
    type: "collapse",
    name: "Bulk Student Upload",
    key: "Bulk-Student-Upload",
    icon: <Icon fontSize="small"></Icon>,
    route: "/bulk-student-upload",
    component: (
      <ProtectedRoute>
        <BulkStudentUpload />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    id: "5",
    type: "collapse",
    name: "Job Role",
    key: "Job Role",
    icon: <Icon fontSize="small">add_circle</Icon>,
    collapse: [
      {
        id: "75",
        bpid: "5",
        mpid: "5",
        type: "collapse",
        name: "Edit Job Details",
        key: "editjobDetails",
        route: "/Job-role/Edit-job-details",
        icon: <Icon fontSize="small">edit</Icon>,
        component: (
          <ProtectedRoute>
            <JobRoleUpload />
          </ProtectedRoute>
        ),
      },
      {
        id: "76",
        bpid: "5",
        mpid: "5",
        type: "collapse",
        name: "Job Work Report",
        key: "jobworkreport",
        route: "/Job-role/Job-work-report",
        icon: <Icon fontSize="small">edit</Icon>,
        component: (
          <ProtectedRoute>
            <JobRoleReport />
          </ProtectedRoute>
        ),
      },
      {
        id: "77",
        bpid: "5",
        mpid: "5",
        type: "collapse",
        name: "Job Role Analytics",
        key: "jobRoleAnalytics",
        route: "/Job-role/Job-Role-Analytics",
        icon: <Icon fontSize="small">edit</Icon>,
        component: (
          <ProtectedRoute>
            <JobRoleAnalytics />
          </ProtectedRoute>
        ),
      },
    ]
  },
  // {
  //   id: "28",
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  {
    id: "25",
    type: "collapse",
    name: "Fuel Log",
    key: "Fuel Log",
    icon: <Icon fontSize="small">manage_accounts_icon </Icon>,
    collapse: [
      {
        id: "26",
        bpid: "25",
        mpid: "25",
        type: "collapse",
        name: "Fuel Log Upload",
        key: "fuelLogUpload",
        route: "/Fuel-log/Fuel-log-upload",
        icon: <Icon fontSize="small">directions_bus_filled_Icon </Icon>,
        component: (
          <ProtectedRoute>
            <FuelLogUpload />
          </ProtectedRoute>
        ),
      },
      {
        id: "27",
        bpid: "25",
        mpid: "25",
        type: "collapse",
        name: "Fuel Log Report",
        key: "fuelLogReport",
        route: "/Fuel-log/Fuel-log-report",
        icon: <Icon fontSize="small">directions_bus_filled_Icon </Icon>,
        component: (
          <ProtectedRoute>
            <FuelLogReport />
          </ProtectedRoute>
        ),
      },
      {
        id: "28",
        bpid: "25",
        mpid: "25",
        type: "collapse",
        name: "Fuel Log Analytics",
        key: "fuelLogAnalytics",
        route: "/Fuel-log/Fuel-log-analytics",
        icon: <Icon fontSize="small">directions_bus_filled_Icon </Icon>,
        component: (
          <ProtectedRoute>
            <FuelLogAnalytics />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    visible: false,
  },
  {
    id: "29",
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    visible: false,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  //   visible: false,
  // },
  {
    id: "202",
    bpid: "20",
    mpid: "20",
    type: "collapse",
    name: "Super GeoFence",
    key: "superGeoFence",
    icon: <Icon fontSize="small">place</Icon>,
    route: "/SuperAdmin/Super-GeoFence",
    component: (
      <ProtectedRoute>
        <SuperGeoFence />
      </ProtectedRoute>
    ),
    visible: false,
  },
  {
    type: "collapse",
    name: "Live",
    key: "live",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/live",
    component: <Live />,
    visible: false,
  },
  {
    type: "collapse",
    name: "Live_Ol_Google",
    key: "Live_Ol_Google",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/live_ol_google",
    component: <Live_Google />,
    visible: false,
  },
  {
    type: "collapse",
    name: "Live_Ol_Google",
    key: "Live_Ol_Google",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/live_singletrack",
    component: <Live_SingleTrack />,
    visible: false,
  },
  {
    type: "collapse",
    name: "Live_Lite",
    key: "Live_Ol_Google",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/live_lite",
    component: <Live_Lite />,
    visible: false,
  },
  {
    type: "collapse",
    name: "Live_Temp",
    key: "Live_Temp",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/live_temp",
    component: <Live_Temp />,
    visible: false,
  },
];

export default routes;
